import { Locales } from "@/enums/enums";
import { GetFileServiceUrl } from "@/helper/uploadHelper";
import { i18n } from "@/i18n";
import { EmployeeDetailModel } from "@/model/employee/employeeDetailModel";
import { EmployeeFinanceChanelDetailModel } from "@/model/employee/employeeFinanceChanelDetailModel";
import { EmployeeHistoryTableModel } from "@/model/employee/employeeHistoryTableModel";
import { EmployeeModel } from "@/model/employee/employeeModel";
import { EmployeeStatementDetailModel } from "@/model/employee/employeeStatementDetailModel";
import { EmployeeTableModel } from "@/model/employee/employeeTableModel";
import { SalaryEmployeeTotalYearlyModel } from "@/model/employee/salaryEmployeeTotalYearlyModel";
export function ConvertToEmployeeTable(table: any) {
  const employeeTable: any = {
    count: table.count,
    tableList: [],
  };

  if (table.tableList !== null && table.tableList.length > 0) {
    table.tableList.forEach((tableItem: any) => {
      const employeeTableModel: EmployeeTableModel = {
        id: tableItem.id,
        code: tableItem.code,
        firstNameTh: tableItem.firstNameTh,
        lastNameTh: tableItem.lastNameTh,
        firstNameEn: tableItem.firstNameEn,
        lastNameEn: tableItem.lastNameEn,
        firstNameLocale: i18n.locale == Locales.TH ? tableItem.firstNameTh : tableItem.firstNameEn,
        lastNameLocale: i18n.locale == Locales.TH ? tableItem.lastNameTh : tableItem.lastNameEn,
        isArchived: tableItem.isArchived,
        accountId: tableItem.accountId,
        departmentId: tableItem.departmentId,
        positionId: tableItem.positionId,
        salaryTotal: tableItem.salaryTotal,
        profileImageUrl: tableItem.profileImageUrl ? GetFileServiceUrl(tableItem.profileImageUrl) : "",
        namePrefixName: tableItem.namePrefixName,
        namePrefixType: tableItem.namePrefixType,
      };

      employeeTable.tableList.push(employeeTableModel);
    });
  }

  return employeeTable;
}

export function ConvertToEmployeeDetail(employeeDetail: any): EmployeeDetailModel {
  const employeeDetailModal: EmployeeDetailModel = {
    id: employeeDetail.id,
    departmentId: employeeDetail.departmentId,
    positionId: employeeDetail.positionId,
    code: employeeDetail.code,
    profileImageUrl: employeeDetail.profileImageUrl ? GetFileServiceUrl(employeeDetail.profileImageUrl) : "",
    idCardFileUrl: employeeDetail.idCardFileUrl ? GetFileServiceUrl(employeeDetail.idCardFileUrl) : "",
    contractFileUrl: employeeDetail.contractFileUrl ? GetFileServiceUrl(employeeDetail.contractFileUrl) : "",
    namePrefixType: employeeDetail.namePrefixType,
    namePrefixName: employeeDetail.namePrefixName,
    firstNameTh: employeeDetail.firstNameTh,
    firstNameEn: employeeDetail.firstNameEn,
    firstNameLocale: i18n.locale == Locales.TH ? employeeDetail.firstNameTh : employeeDetail.firstNameEn,
    lastNameTh: employeeDetail.lastNameTh,
    lastNameEn: employeeDetail.lastNameEn,
    lastNameEnLocale: i18n.locale == Locales.TH ? employeeDetail.lastNameTh : employeeDetail.lastNameEn,
    identifyPersionType: employeeDetail.identifyPersionType,
    citizenIdCode: employeeDetail.citizenIdCode,
    passportIdCode: employeeDetail.passportIdCode,
    email: employeeDetail.email,
    phone: employeeDetail.phone,
    emergencyContactName: employeeDetail.emergencyContactName,
    emergencyContactPhone: employeeDetail.emergencyContactPhone,
    address: employeeDetail.address,
    subDistrict: employeeDetail.subDistrict,
    city: employeeDetail.city,
    province: employeeDetail.province,
    postCode: employeeDetail.postCode,
    employeeStartDate: employeeDetail.employeeStartDate,
    employeeEndDate: employeeDetail.employeeEndDate,
    salaryTotal: employeeDetail.salaryTotal,
    isRegisterSSO: employeeDetail.isRegisterSSO,
    isWht: employeeDetail.isWht,
    pndType: employeeDetail.pndType,
    whtAmount: employeeDetail.whtAmount,
    prompPayNumber: employeeDetail.prompPayNumber,
    prompPayType: employeeDetail.prompPayType,
    bankAccountBranchNumber: employeeDetail.bankAccountBranchNumber,
    bankAccountBranchName: employeeDetail.bankAccountBranchName,
    bankAccountNumber: employeeDetail.bankAccountNumber,
    bankAccountName: employeeDetail.bankAccountName,
    bankType: employeeDetail.bankType,
    bankReferenceId: employeeDetail.bankReferenceId,
    financeChanelType: employeeDetail.financeChanelType,
    accountId: employeeDetail.accountId,
    isDeleted: employeeDetail.isDelete,
    isArchived: employeeDetail.isArchived,
    contactType: employeeDetail.contactType,
    employeeResignReasonTypeId:
      employeeDetail.employeeResignReasonTypeId !== null ? employeeDetail.employeeResignReasonTypeId : null,
    employeeResignNote: employeeDetail.employeeResignNote ? employeeDetail.employeeResignNote : "",
  };
  return employeeDetailModal;
}

export function ConverToEmloyeeList(employeeList: any): Array<EmployeeModel> {
  const employeeListModel: Array<EmployeeModel> = [];
  if (employeeList && employeeList.length > 0) {
    employeeList.forEach((employee: any) => {
      let profileImageUrl = "";
      if (employee.profileImageUrl) {
        profileImageUrl = GetFileServiceUrl(employee.profileImageUrl);
      }
      const employeeModel: EmployeeModel = {
        id: employee.id,
        departmentId: employee.departmentId,
        positionId: employee.positionId,
        code: employee.code,
        profileImageUrl: profileImageUrl,
        namePrefixType: employee.namePrefixType,
        namePrefixName: employee.namePrefixName,
        firstNameTh: employee.firstNameTh,
        firstNameEn: employee.firstNameEn,
        firstNameLocale: i18n.locale == Locales.TH ? employee.firstNameTh : employee.firstNameEn,
        lastNameTh: employee.lastNameTh,
        lastNameEn: employee.lastNameEn,
        lastNameLocale: i18n.locale == Locales.TH ? employee.lastNameTh : employee.lastNameEn,
        identifyPersionType: employee.identifyPersionType,
        citizenIdCode: employee.citizenIdCode,
        passportIdCode: employee.passportIdCode,
        email: employee.email,
        phone: employee.phone,
        emergencyContactName: employee.emergencyContactName,
        emergencyContactPhone: employee.emergencyContactPhone,
        address: employee.address,
        subDistrict: employee.subDistrict,
        city: employee.city,
        province: employee.province,
        postCode: employee.postCode,
        employeeStartDate: employee.employeeStartDate,
        employeeEndDate: employee.employeeEndDate,
        salaryTotal: employee.salaryTotal,
        isRegisterSSO: employee.isRegisterSSO,
        isWht: employee.isWht,
        pndType: employee.pndType,
        whtAmount: employee.whtAmount,
        prompPayNumber: employee.prompPayNumber,
        prompPayType: employee.prompPayType,
        bankAccountBranchNumber: employee.bankAccountBranchNumber,
        bankAccountBranchName: employee.bankAccountBranchName,
        bankAccountNumber: employee.bankAccountNumber,
        bankAccountName: employee.bankAccountName,
        bankType: employee.bankType,
        bankReferenceId: employee.bankReferenceId,
        financeChanelType: employee.financeChanelType,
        accountId: employee.accountId,
        contactType: employee.contactType,
        isArchived: employee.isArchived,
      };
      employeeListModel.push(employeeModel);
    });
  }
  return employeeListModel;
}

export function ConvertToEmployeeFinanceChanelDetailList(employeeList: any): Array<EmployeeFinanceChanelDetailModel> {
  const employeeListModel: Array<EmployeeFinanceChanelDetailModel> = [];
  if (employeeList && employeeList.length > 0) {
    employeeList.forEach((employee: any) => {
      let profileImageUrl = "";
      if (employee.profileImageUrl) {
        profileImageUrl = GetFileServiceUrl(employee.profileImageUrl);
      }
      const employeeModel: EmployeeFinanceChanelDetailModel = {
        id: employee.id,
        code: employee.code,
        profileImageUrl: profileImageUrl,
        namePrefixType: employee.namePrefixType,
        namePrefixName: employee.namePrefixName,
        firstNameTh: employee.firstNameTh,
        firstNameEn: employee.firstNameEn,
        firstNameLocale: i18n.locale == Locales.TH ? employee.firstNameTh : employee.firstNameEn,
        lastNameTh: employee.lastNameTh,
        lastNameEn: employee.lastNameEn,
        lastNameLocale: i18n.locale == Locales.TH ? employee.lastNameTh : employee.lastNameEn,
        identifyPersionType: employee.identifyPersionType,
        prompPayNumber: employee.prompPayNumber,
        prompPayType: employee.prompPayType,
        bankAccountBranchNumber: employee.bankAccountBranchNumber,
        bankAccountBranchName: employee.bankAccountBranchName,
        bankAccountNumber: employee.bankAccountNumber,
        bankAccountName: employee.bankAccountName,
        bankType: employee.bankType,
        bankReferenceId: employee.bankReferenceId,
        financeChanelType: employee.financeChanelType,
      };
      employeeListModel.push(employeeModel);
    });
  }
  return employeeListModel;
}

export function ConvertToEmployeeStatementDetailList(employeeList: any): Array<EmployeeStatementDetailModel> {
  const employeeListModel: Array<EmployeeStatementDetailModel> = [];
  if (employeeList && employeeList.length > 0) {
    employeeList.forEach((employee: any) => {
      let profileImageUrl = "";
      if (employee.profileImageUrl) {
        profileImageUrl = GetFileServiceUrl(employee.profileImageUrl);
      }
      /* eslint-disable @typescript-eslint/camelcase */
      const employeeModel: EmployeeStatementDetailModel = {
        employeeId: employee.employeeId,
        code: employee.code,
        email: employee.email,
        profileImageUrl: profileImageUrl,
        employeeFirstNameTh: employee.employeeFirstNameTh,
        employeeFirstNameEn: employee.employeeFirstNameEn,
        firstNameLocale: i18n.locale == Locales.TH ? employee.employeeFirstNameTh : employee.employeeFirstNameEn,
        employeeLastNameTh: employee.employeeLastNameTh,
        employeeLastNameEn: employee.employeeLastNameEn,
        lastNameLocale: i18n.locale == Locales.TH ? employee.employeeLastNameTh : employee.employeeLastNameEn,
        identifyPersionType: employee.identifyPersionType,
        prompPayNumber: employee.prompPayNumber,
        prompPayType: employee.prompPayType,
        bankAccountBranchNumber: employee.bankAccountBranchNumber,
        bankAccountBranchName: employee.bankAccountBranchName,
        bankAccountNumber: employee.bankAccountNumber,
        bankAccountName: employee.bankAccountName,
        bankType: employee.bankType,
        bankReferenceId: employee.bankReferenceId,
        financeChanelType: employee.financeChanelType,
        positionId: employee.positionId,
        passportIdCode: employee.passportIdCode,
        positionNameEn: employee.positionNameEn,
        positionNameTh: employee.positionNameTh,
        departmentNameEn: employee.departmentNameEn,
        departmentNameTh: employee.departmentNameTh,
        deparmentId: employee.deparmentId,
        employeeNamePrefixName: employee.employeeNamePrefixName,
        employeeNamePrefixType: employee.employeeNamePrefixType,
        citizenIdCode: employee.citizenIdCode,
      };
      employeeListModel.push(employeeModel);
    });
  }
  return employeeListModel;
}

export function ConvertToEmployeeHistoryTable(table: any) {
  const employeeHistoryTable: any = {
    count: table.count,
    tableList: [],
  };

  if (table.employeeHistorySalaryModels !== null && table.employeeHistorySalaryModels.length > 0) {
    table.employeeHistorySalaryModels.forEach((tableItem: any) => {
      const employeeHistoryTableModel: EmployeeHistoryTableModel = {
        salaryId: tableItem.salaryId,
        salaryNumber: tableItem.salaryNumber,
        salaryIssuedDate: tableItem.salaryIssuedDate,
        employeeId: tableItem.employeeId,
        salaryTotal: tableItem.salaryTotal,
        socialSecurityFundTotal: tableItem.socialSecurityFundTotal,
        whtTotal: tableItem.whtTotal,
        revenueTotal: tableItem.revenueTotal,
        deductionTotal: tableItem.deductionTotal,
        netAmount: tableItem.netAmount,
        status: tableItem.status,
        isIssuedStatement: tableItem.isIssuedStatement,
      };

      employeeHistoryTable.tableList.push(employeeHistoryTableModel);
    });
  }

  return employeeHistoryTable;
}

export function ConvertToEmployeeTotalYearlyList(_employeeTotalYearlyList: any) {
  const salaryEmployeeTotalYearlyList: Array<SalaryEmployeeTotalYearlyModel> = [];
  if (_employeeTotalYearlyList && _employeeTotalYearlyList.length > 0) {
    _employeeTotalYearlyList.forEach((employeeTotalYearly: any) => {
      const salaryEmployeeTotalYearly: SalaryEmployeeTotalYearlyModel = {
        employeeId: employeeTotalYearly.employeeId,
        grossSalaryAmount: employeeTotalYearly.grossSalaryAmount,
        taxCalculatedAmount: employeeTotalYearly.taxCalculatedAmount,
        whtTotal: employeeTotalYearly.whtTotal,
      };
      salaryEmployeeTotalYearlyList.push(salaryEmployeeTotalYearly);
    });
  }
  return salaryEmployeeTotalYearlyList;
}
